import { ANALYTICS_EVENTS } from '../events'
import createAnalyticsStatic, { EventProps } from './createAnalyticsEvent'

/**
 * Props for PortfolioViewClicked event.
 *
 * @property view - selected portfolio view (e.g., 'Day' | 'Total')
 */
export interface PortfolioViewClickedProps extends EventProps {
    view: string
}

/**
 * @event PortfolioViewClicked
 * @description Emitted when the portfolio view selector is used.
 */
export const PortfolioViewClickedAnalytics = createAnalyticsStatic<PortfolioViewClickedProps>(
    ANALYTICS_EVENTS.PORTFOLIO.PORTFOLIO_VIEW_CLICKED,
)

export default PortfolioViewClickedAnalytics
